<div class="">
  <ng-container *ngIf="description && !isEditDescription">
    <div class="text-gray-600 mb-1">
      <span>Description</span>
    </div>
  </ng-container>
  <div class="text-area" [class.no-height]="!isEditDescription">
    <textarea id="description-editor" class="w-full"></textarea>
  </div>
</div>